var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.59596 12.9685L7.41547 12.8915L7.23498 12.9685L1.30677 15.496C1.17872 15.5441 1.08483 15.5466 1.0128 15.531C0.920144 15.511 0.850532 15.472 0.791882 15.4134L0.533277 15.672L0.791881 15.4134C0.737649 15.3592 0.696681 15.2883 0.674782 15.184C0.657293 15.1007 0.661598 15.0026 0.707954 14.8789L6.98472 0.738953L6.98484 0.739002L6.9889 0.729238C7.02951 0.631775 7.08296 0.575601 7.14921 0.537811C7.24861 0.481123 7.33549 0.460199 7.41547 0.460199C7.49631 0.460199 7.58293 0.481248 7.68108 0.537436C7.7471 0.575239 7.80114 0.631861 7.84255 0.730443L7.84246 0.730479L7.84622 0.738953L14.1227 14.8783C14.1686 15.0019 14.1728 15.1003 14.1552 15.184L14.6056 15.2786L14.1552 15.184C14.1333 15.2886 14.0924 15.3596 14.0387 15.4137C13.981 15.4713 13.9113 15.5107 13.817 15.5313C13.7448 15.5471 13.6517 15.5445 13.525 15.4964L7.59596 12.9685Z",
    stroke: "#F0F0F0",
    strokeWidth: 0.920398
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/Navigation.9d34b5dea56daad27df03dd8b2780d80.svg";
export { ForwardRef as ReactComponent };